import { render, staticRenderFns } from "./ViolationFormAcceptance.vue?vue&type=template&id=423dce56&"
import script from "./ViolationFormAcceptance.vue?vue&type=script&lang=ts&"
export * from "./ViolationFormAcceptance.vue?vue&type=script&lang=ts&"
import style0 from "./ViolationFormAcceptance.vue?vue&type=style&index=0&id=423dce56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports